import { ShieldCheck } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import { SectionTitle } from "@/components/ui/section-title";

// Áreas do sistema com a permissão de ver e a de alterar (sem "alterar": só consulta)
const AREAS: { nome: string; ver: string; alterar?: string }[] = [
  { nome: 'Seguros e sinistros', ver: 'ROLE_SEGURO_READ', alterar: 'ROLE_SEGURO_WRITE' },
  { nome: 'Segurados', ver: 'ROLE_SEGURADO_READ', alterar: 'ROLE_SEGURADO_WRITE' },
  { nome: 'Seguradoras', ver: 'ROLE_SEGURADORA_READ', alterar: 'ROLE_SEGURADORA_WRITE' },
  { nome: 'Usuários', ver: 'ROLE_USUARIO_READ', alterar: 'ROLE_USUARIO_WRITE' },
  { nome: 'Dados da corretora', ver: 'ROLE_EMPRESA_READ', alterar: 'ROLE_EMPRESA_WRITE' },
  { nome: 'Auditoria', ver: 'ROLE_AUDITORIA_READ' },
];

const SENHAS = [
  { id: 'ROLE_USUARIO_CHANGE_PASSWORD', nome: 'Alterar a própria senha' },
  { id: 'ROLE_USUARIO_CHANGE_ALL_PASSWORD', nome: 'Alterar a senha de qualquer usuário' },
];

type PermissoesSectionProps = {
  administrador: boolean;
  permissoes: string[];
  onChange(permissoes: string[]): void;
}

export const PermissoesSection = ({ administrador, permissoes, onChange }: PermissoesSectionProps) => {
  const tem = (p: string) => administrador || permissoes.includes(p);
  const alternar = (adicionar: string[], remover: string[]) =>
    onChange(Array.from(new Set(permissoes.filter(x => !remover.includes(x)).concat(adicionar))));

  return (
    <>
    <SectionTitle icon={<ShieldCheck />} cor="bg-violet-500/10 text-violet-600 dark:text-violet-400"
      description={administrador ? 'Administrador da corretora: tem acesso a tudo.' : 'Quem pode alterar também pode ver.'}>
      Permissões
    </SectionTitle>
    <div className="overflow-hidden rounded-lg border">
      <table className="w-full text-sm">
        <thead className="bg-muted/40 text-xs text-muted-foreground">
          <tr>
            <th className="px-4 py-2 text-left font-medium">Área</th>
            <th className="w-24 px-4 py-2 text-center font-medium">Ver</th>
            <th className="w-24 px-4 py-2 text-center font-medium">Alterar</th>
          </tr>
        </thead>
        <tbody className="divide-y">
          {AREAS.map(area => (
            <tr key={area.nome}>
              <td className="px-4 py-2.5">{area.nome}</td>
              <td className="px-4 py-2.5 text-center">
                {/* Desmarcar "ver" desmarca "alterar" */}
                <Checkbox aria-label={`Ver ${area.nome}`} disabled={administrador} checked={tem(area.ver)}
                  onCheckedChange={v => v === true ? alternar([area.ver], []) : alternar([], area.alterar ? [area.ver, area.alterar] : [area.ver])} />
              </td>
              <td className="px-4 py-2.5 text-center">
                {/* Marcar "alterar" marca "ver" */}
                {area.alterar ? (
                  <Checkbox aria-label={`Alterar ${area.nome}`} disabled={administrador} checked={tem(area.alterar)}
                    onCheckedChange={v => v === true ? alternar([area.alterar!, area.ver], []) : alternar([], [area.alterar!])} />
                ) : <span className="text-muted-foreground/60">—</span>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    <div className="mt-4 space-y-2">
      {SENHAS.map(senha => (
        <label key={senha.id} className="flex items-center gap-2.5 text-sm">
          <Checkbox disabled={administrador} checked={tem(senha.id)} onCheckedChange={v => v === true ? alternar([senha.id], []) : alternar([], [senha.id])} />
          {senha.nome}
        </label>
      ))}
    </div>
    </>
  );
}
